import React from 'react';

const Home: React.VFC = () => (
  <svg width="31" height="26" viewBox="0 0 31 26" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M15.5 4.29792L22.7917 10.8604V22.25H19.875V13.5H11.125V22.25H8.20835V10.8604L15.5 4.29792ZM15.5 0.375L0.916687 13.5H5.29169V25.1667H14.0417V16.4167H16.9584V25.1667H25.7084V13.5H30.0834L15.5 0.375Z" fill="#333333" />
  </svg>
);

export default Home;
